import { createContext, useState, useRef, useMemo, useEffect } from 'react';
import { showGenericUpdateFailure } from 'calling-orchestration-shared-library/alert-store/operators/alertMessageUtils';
import { initialSearchState } from '../types/TranscriptSearchStateInterface';
import { getSearchResultsAndTranscript } from '../utils/termSearch';
import { getTranscriptSetting } from '../apis/TranscriptSettingApi';
import { jsx as _jsx } from "react/jsx-runtime";
export const TranscriptContext = /*#__PURE__*/createContext({});
export const TranscriptContextProvider = props => {
  const {
    callSource,
    assignedUser,
    isTranscriptionAdmin,
    hasTranscriptionFeature,
    hasSalesStarterSeat,
    hasServiceStarterSeat,
    callOwnerHasTranscriptionScope,
    transcriptionStatus,
    isTranscriptUsageLimitReached,
    transcriptUtterances,
    transcriptParticipants,
    onOpenTranscriptTab,
    onMapSpeaker,
    onUnmapSpeaker,
    onTranscriptSearchCallback,
    onTranscriptAutoScrollClickCallback,
    usageTracker,
    children
  } = props;
  const [searchState, setSearchState] = useState(initialSearchState);
  const [autoScrollTranscript, setAutoScrollTranscript] = useState(true);
  const [selectedUtteranceId, setSelectedUtteranceId] = useState('');
  const [selectedUtteranceIndex, setSelectedUtteranceIndex] = useState(-1);
  const [selectedResultIndex, setSelectedResultIndex] = useState(0);
  const [isMatchingPopoverOpen, setIsMatchingPopoverOpen] = useState(false);
  const firstUnmatchedUtteranceIdRef = useRef(null);
  const [isTranscriptSettingEnabled, setIsTranscriptSettingEnabled] = useState(false);
  const [isTranscriptSettingLoading, setIsTranscriptSettingLoading] = useState(false);
  useEffect(() => {
    setIsTranscriptSettingLoading(true);
    getTranscriptSetting().then(isEnabled => {
      setIsTranscriptSettingEnabled(isEnabled);
      setIsTranscriptSettingLoading(false);
    }).catch(() => {
      showGenericUpdateFailure();
      setIsTranscriptSettingLoading(false);
    });
  }, []);
  const {
    highlightedOrFullTranscript,
    totalMatches,
    resultIndexPerUtterance,
    matchedUtterance
  } = useMemo(() => transcriptUtterances && searchState.term ? getSearchResultsAndTranscript(transcriptUtterances, searchState.term, selectedResultIndex, searchState.searchType) : {
    highlightedOrFullTranscript: transcriptUtterances,
    totalMatches: 0,
    resultIndexPerUtterance: [],
    matchedUtterance: null
  }, [transcriptUtterances, searchState.term, selectedResultIndex, searchState.searchType]);
  const handleSelectResult = result => {
    setSelectedResultIndex(result);
  };
  const debouncedOnSearch = useRef(onTranscriptSearchCallback);
  const handleSearch = searchData => {
    debouncedOnSearch.current();
    setSearchState(searchData);
  };
  const contextValue = {
    callSource,
    assignedUser,
    hasSalesStarterSeat,
    hasServiceStarterSeat,
    isTranscriptionAdmin,
    isTranscriptSettingLoading,
    hasTranscriptionFeature,
    callOwnerHasTranscriptionScope,
    transcriptionStatus,
    isTranscriptUsageLimitReached,
    isTranscriptSettingEnabled,
    totalMatches,
    highlightedOrFullTranscript,
    firstUnmatchedUtteranceIdRef,
    autoScrollTranscript,
    setAutoScrollTranscript,
    selectedUtteranceId,
    setSelectedUtteranceId,
    selectedUtteranceIndex,
    setSelectedUtteranceIndex,
    setIsMatchingPopoverOpen,
    isMatchingPopoverOpen,
    transcriptParticipants,
    resultIndexPerUtterance,
    selectedResultIndex,
    matchedUtterance,
    searchState,
    onMapSpeaker,
    onUnmapSpeaker,
    onOpenTranscriptTab,
    handleSelectResult,
    handleSearch,
    onTranscriptAutoScrollClickCallback,
    usageTracker,
    transcriptUtterances
  };
  return /*#__PURE__*/_jsx(TranscriptContext.Provider, {
    value: contextValue,
    children: children
  });
};